const Card = ({ title, actions, children }) => {
  return (
    <div className="food-card mt-4 px-10 py-10">
      <div className="food-card-header">
        <div className="food-card-header-title">{title}</div>
        {actions}
      </div>

      {/* Hoolnii jagsaalt */}
      <div className="flex w-full flex-wrap gap-10">{children}</div>
    </div>
  );
};

export default Card;
